import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';

const tableWithTotal = (data) => {
  const sourced_candidates_total = data?.reduce(
    (acc, curr) => acc + curr?.sourced_candidates,
    0
  );
  const screened_candidates_total = data?.reduce(
    (acc, curr) => acc + curr?.screened_candidates,
    0
  );
  const interviews_scheduled_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_scheduled,
    0
  );
  const interviews_conducted_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_conducted,
    0
  );
  const offers_sent_total = data?.reduce(
    (acc, curr) => acc + curr?.offers_sent,
    0
  );
  const offer_revisions_done_total = data?.reduce(
    (acc, curr) => acc + curr?.offer_revisions_done,
    0
  );
  const hired_candidates_total = data?.reduce(
    (acc, curr) => acc + curr?.hired_candidates,
    0
  );
  const rejected_candidates_total = data?.reduce(
    (acc, curr) => acc + curr?.rejected_candidates,
    0
  );
  const offers_accepted_total = data?.reduce(
    (acc, curr) => acc + curr?.offers_accepted,
    0
  );
  const time_to_offer_total = data?.reduce(
    (acc, curr) => acc + curr?.time_to_offer,
    0
  );
  const time_to_hire_total = data?.reduce(
    (acc, curr) => acc + curr?.time_to_hire,
    0
  );
  const interview_rescheduled_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_rescheduled,
    0
  );
  const interviews_cancelled_total = data?.reduce(
    (acc, curr) => acc + (curr?.interviews_cancelled || 0),
    0
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        sourced_candidates_total,

        screened_candidates_total,

        interviews_scheduled_total,

        interviews_conducted_total,

        offers_sent_total,

        offer_revisions_done_total,

        hired_candidates_total,

        rejected_candidates_total,

        offers_accepted_total,

        time_to_offer_total,

        time_to_hire_total,

        interview_rescheduled_total,

        interviews_cancelled_total,

        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

export const performanceTableTransformer = ({ response, args }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  const tableData = tableWithTotal(transformedData);

  return tableData;
};
